export default "__VITE_ASSET__ac36d155__"